import { phoneNumberFormatting, getName } from "js/formatting";
import { useTranslation } from "react-i18next";

import CardWithFields from "components/General/CardWithFields";

export default function OwnerCard({ loggedInOwner, additionalOwners }) {
  const { t } = useTranslation();
  const { addressLine1, addressLine2, city, postalCode, state } =
    loggedInOwner.address;
  const { phoneNumber } = loggedInOwner.phone;
  const { address: emailAddress } = loggedInOwner.email;

  const getTitle = (key) => {
    return t(`${key}`);
  };

  return (
    <CardWithFields
      additionalContent={
        additionalOwners.length > 0 && (
          <>
            <hr />
            <div className="px-4 pb-4 overflow-hidden h-20 mt-4 md:h-auto md:mt-0 xl:px-6 xl:pb-6">
              <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:gap-6">
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("CustomerPolicyDetails-owner-additional-owner")}
                  </div>

                  {additionalOwners.map((owner) => (
                    <div
                      key={owner.person?.personId}
                      className="text-sm text-theme-text-secondary font-semibold"
                    >
                      {getName(owner.person)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )
      }
      ariaLabel={t("CustomerPolicyDetails-owner-aria-label")}
      cardTitle={t("CustomerPolicyDetails-owner-card-title")}
      cardFields={[
        {
          title: getTitle("CustomerPolicyDetails-owner"),
          value: getName(loggedInOwner.person),
        },
        {
          title: getTitle("CustomerPolicyDetails-owner-address"),
          value: (
            <>
              {addressLine1}
              <p>{addressLine2}</p>
              {`${city}, ${state} ${postalCode.substring(0, 5)}`}
            </>
          ),
        },
        {
          title: getTitle("CustomerPolicyDetails-owner-phone"),
          value: (
            <a href={`tel:+1${phoneNumber}`}>
              {phoneNumberFormatting(phoneNumber)}
            </a>
          ),
        },
        {
          title: getTitle("CustomerPolicyDetails-owner-email"),
          value: (
            <a href={`mailto:${emailAddress}`} className="break-all">
              {emailAddress}
            </a>
          ),
        },
      ]}
    />
  );
}
